"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioSessionServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let AudioSessionService = class AudioSessionService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
    }
    /**
     * Create audio session
     */
    async createAudioSession(request) {
        try {
            const response = await this.apiService.back.post('audio.create-session', request);
            return response;
        }
        catch (error) {
            console.error('Failed to create audio session:', error);
            return {
                success: false,
                error: error.message || 'Failed to create audio session'
            };
        }
    }
    /**
     * Get audio session
     */
    async getAudioSession(sessionId) {
        try {
            const response = await this.apiService.back.get('audio.get-session', { routeParams: { sessionId } });
            return response;
        }
        catch (error) {
            console.error('Failed to get audio session:', error);
            return {
                success: false,
                error: error.message || 'Failed to get audio session'
            };
        }
    }
    /**
     * End audio session
     */
    async endAudioSession(sessionId) {
        try {
            const response = await this.apiService.back.delete('audio.end-session', { routeParams: { sessionId } });
            return response;
        }
        catch (error) {
            console.error('Failed to end audio session:', error);
            return {
                success: false,
                error: error.message || 'Failed to end audio session'
            };
        }
    }
    /**
     * Start audio conversation
     */
    async startAudioConversation(conversationId, voiceId, language) {
        try {
            const response = await this.apiService.back.post('audio.start-conversation', { conversationId, voiceId, language });
            return response;
        }
        catch (error) {
            console.error('Failed to start audio conversation:', error);
            return {
                success: false,
                error: error.message || 'Failed to start audio conversation'
            };
        }
    }
    /**
     * Process audio conversation (send audio, get audio response)
     */
    async processAudioConversation(audioBlob, sessionId, language, streamResponse = false) {
        try {
            const formData = new FormData();
            formData.append('audio', audioBlob, 'conversation.webm');
            formData.append('sessionId', sessionId);
            if (language) {
                formData.append('language', language);
            }
            formData.append('streamResponse', streamResponse.toString());
            if (streamResponse) {
                // Handle streaming response
                const response = await fetch('/api/audio/process-conversation', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.apiService.token}`
                    },
                    body: formData
                });
                if (response.ok && response.body) {
                    // Return the stream for external handling
                    return true;
                }
                return false;
            }
            else {
                // Get regular response using fetch instead of postFormData
                const response = await fetch('/api/audio/process-conversation', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.apiService.token}`
                    },
                    body: formData
                });
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }
                const result = await response.json();
                return result;
            }
        }
        catch (error) {
            console.error('Failed to process audio conversation:', error);
            return streamResponse ? false : {
                success: false,
                error: error.message || 'Failed to process audio conversation'
            };
        }
    }
    /**
     * Text to audio conversation
     */
    async textToAudioConversation(request) {
        try {
            if (request.streamAudio) {
                // Handle streaming response
                const response = await fetch('/api/audio/text-conversation', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.apiService.token}`
                    },
                    body: JSON.stringify(request)
                });
                if (response.ok && response.body) {
                    return true;
                }
                return false;
            }
            else {
                const response = await this.apiService.back.post('audio.text-conversation', request);
                return response;
            }
        }
        catch (error) {
            console.error('Failed to process text to audio conversation:', error);
            return request.streamAudio ? false : {
                success: false,
                error: error.message || 'Failed to process text to audio conversation'
            };
        }
    }
    /**
     * Change session voice
     */
    async changeSessionVoice(sessionId, voiceId) {
        try {
            const response = await this.apiService.back.put('audio.change-voice', { sessionId, voiceId });
            return response;
        }
        catch (error) {
            console.error('Failed to change session voice:', error);
            return {
                success: false,
                error: error.message || 'Failed to change session voice'
            };
        }
    }
    /**
     * Get session stats (admin only)
     */
    async getSessionStats() {
        try {
            const response = await this.apiService.back.get('audio.session-stats');
            return response;
        }
        catch (error) {
            console.error('Failed to get session stats:', error);
            return {
                success: false,
                error: error.message || 'Failed to get session stats'
            };
        }
    }
};
exports.AudioSessionServiceInstance = AudioSessionService;
exports.AudioSessionServiceInstance = AudioSessionService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], AudioSessionService);
exports.default = AudioSessionService.getSingleton();
